import { round } from 'lodash';

import { ensureDefined } from '@e-socna/utils';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

import { useSIGDistanceExacteMissionAgenceEnKmAuPlusCourt } from './useSIGDistanceExacteMissionAgenceEnKmAuPlusCourt.resolver';

export const useSIGDistanceArrondieMissionAgenceEnKmAuPlusCourt = (
  parameters: ResolverParameters,
): ResolverResult<number | string> => {
  const exactResult =
    useSIGDistanceExacteMissionAgenceEnKmAuPlusCourt(parameters);

  if (!exactResult.isSuccess) {
    return {
      ...exactResult,
      data: undefined,
    };
  }

  const { data } = ensureDefined({
    data: exactResult.data,
  });

  return {
    data: {
      generated:
        typeof data.generated === 'string'
          ? data.generated
          : round(data.generated, 2),
    },
    error: null,
    isLoading: false,
    isSuccess: true,
  };
};
